import { chargesCount } from "../../src/money.ts";
import type { Item } from "../../src/web/types.ts";
import { paidMoney, roundMoney } from "./format.ts";

// What a card's At a glance says in words (CardSections.tsx; DESIGN.md, "A card reads in sections"), apart so it can
// be tested without a page.

// Its references as people copy them: two rooms' written as one ("3906-5167-1399 / 3906-5168-9376") are two.
export { refsOf } from "../../src/booking-refs.ts";

// What it costs and what's left to pay (DESIGN.md: "¥79,200, pay at the hotel", "SGD 1,485.42, paid"): an estimate
// as about so much; a price, and once it's booked, what's been paid of it in its own currency. Booked with nothing
// paid or charged, a stay is paid at the hotel; anything else isn't paid yet. A payment in another currency can't be
// set against the price: the price alone, its payments said under Booking. Amounts through src/money.ts's paidMoney
// and roundMoney, which never throw, whatever the currency (DESIGN.md, the log row "Money without an estimate"). `people`: how many a price per person is
// for when its booking doesn't say (the trip's members, as Money counts it).
export function costWords(item: Item, people: number): string | null {
  const c = item.cost;
  if (!c) return null;
  const per = c.per === "person" ? " per person" : "";
  if (c.estimate) return `About ${roundMoney(c.amount, c.currency)}${per}`;
  const price = `${paidMoney(c.amount, c.currency)}${per}`;
  const paid = item.paid ?? [];
  const charged = chargesCount(item.status) ? (item.charges ?? []) : [];
  if (paid.length === 0 && charged.length === 0)
    return item.status === "booked" ? `${price}, ${item.type === "stay" ? "pay at the hotel" : "not paid yet"}` : price;
  if (![...paid, ...charged].every((p) => p.currency === c.currency)) return price;
  const total = c.amount * (c.per === "person" ? item.booking?.for?.length || people : 1);
  const sum = (list: { amount: number }[]) => list.reduce((s, p) => s + p.amount, 0);
  const [inPaid, inCharges] = [sum(paid), sum(charged)];
  const left = total - inPaid - inCharges;
  if (left < 0.005)
    return `${price}, ${inCharges === 0 ? "paid" : inPaid === 0 ? "charged later" : `${paidMoney(inCharges, c.currency)} charged later`}`;
  return `${price}, ${[inCharges > 0 && `${paidMoney(inCharges, c.currency)} charged later`, `${paidMoney(left, c.currency)} left to pay`].filter(Boolean).join(", ")}`;
}
